//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        rotation: {
            default: 0
        }
    },
    computed: {
        rotateStyle(){
            return {
                "transform": `rotate(${this.rotation}deg)`
            }
        }
    }
}
